import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';

interface UpdateSignaturePayload {
  signature: string;
}

export const updateSignature = async (payload: UpdateSignaturePayload) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const formData = new FormData();
  // The signature data is a base64 string, but it needs to be sent as a file-like object.
  // We can convert it to a Blob to accomplish this.
  const response = await fetch(payload.signature);
  const blob = await response.blob();
  formData.append('user_signature', blob, 'signature.png');

  const res = await axiosInterceptor.patch('/user/update-signature/', formData, {
    headers: {
      Authorization: token,
      'Content-Type': 'multipart/form-data',
    },
  });

  return res.data;
};
